module.exports = __webpack_public_path__ + "static/img/img_login_code.58c424a0.png";